import { Component, OnInit } from '@angular/core';

import {
	RoleService,
	AUTHACTIONS
} from '@cv-invision/core';

@Component({
	selector: 'cv-invision-not-allowed',
	template: '',
})
export class NotAllowedComponent implements OnInit {

	constructor(
		private roleService: RoleService,
	) {
	}

	ngOnInit(): void {
		// If the users get into this component means it does not have permissions for any
		// section of Global Configuration
		this.roleService.unAuthSetValues(AUTHACTIONS.UNAUTHORIZED);
	}
}
